<fp-current-user
    *ngIf="fullName"
    [language]="language$ | async"
    [fullName]="fullName"
    [impersonatedByFullName]="impersonatedByFullName"
></fp-current-user>
